import React from 'react'
import PageHeader from '@/components/Common/PageHeader'
import SEOHead from '@/components/SEO/SEOHead'
import { buildGraph, breadcrumbListData, webPageSchema } from '@/data/structured-data'

const TermsPage: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Kullanım Şartları | Ardıç Veteriner Kliniği"
        description="Ardıç Veteriner Kliniği web sitesi kullanım koşulları: içeriklerin kapsamı, tıbbi bilgilendirme sınırları ve sorumluluk esasları hakkında bilgi."
        canonicalUrl="/terms"
        structuredData={buildGraph(
          webPageSchema({ name: 'Kullanım Şartları', description: 'Ardıç Veteriner Kliniği web sitesi kullanım şartları ve sorumluluk reddi.', url: '/terms' }),
          breadcrumbListData([
            { name: 'Ana Sayfa', url: '/' },
            { name: 'Kullanım Şartları', url: '/terms' }
          ])
        )}
      />
      <PageHeader title="Kullanım Şartları" subtitle="Web sitemizi kullanırken geçerli olan kurallar ve koşullar." />
      <section className="section-padding">
        <div className="container-custom">
          <div className="bg-white border rounded-xl p-8 text-gray-700 space-y-4">
            <p>Bu web sitesini kullanarak aşağıdaki şartları kabul etmiş sayılırsınız.</p>
            <h2 className="text-lg font-bold">Genel Kullanım</h2>
            <p>İçerikler bilgilendirme amaçlıdır ve veteriner hekim muayenesinin yerini tutmaz.</p>
            <h2 className="text-lg font-bold">Sorumluluk Reddi</h2>
            <p>Site içeriğinden doğabilecek zararlardan klinik sorumlu tutulamaz.</p>
          </div>
        </div>
      </section>
    </>
  )
}

export default TermsPage


